import styled from "styled-components"

const BurgerSpan = styled.span`
  background: ${(props) => props.theme.c_color_gradients.c_dark};
`
const SearchButton = styled.div`
  background-color: ${(props) =>
    props.className === props.activeSearch
      ? props.theme.a_color_gradients.a_dark
      : null};
  & > svg {
    color: ${(props) => props.theme.c_color_gradients.c_dark};
  }
`

const MenuTitle = styled.p`
  color: ${(props) => props.theme.c_color_gradients.c_dark};
`

const LogoSite = styled.div`
  & svg,
  & path {
    fill: ${(props) => props.theme.b_color_gradients.b_dark}!important;
  }
`

const BackgroundText = styled.div`
  background-color: ${(props) => props.theme.b_color_gradients.b_dark};
`

export { BurgerSpan, SearchButton, LogoSite, MenuTitle, BackgroundText }
